import { Component, OnInit, Input, OnChanges, ChangeDetectorRef } from '@angular/core';
import { Customer, MeteringPoint, MeteringPointSettings } from '@model';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromMeteringPointsStore from '@appStore/metering-points';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-metering-point-old-uc-linking',
    templateUrl: './metering-point-old-uc-linking.component.html',
    standalone: false
})
export class MeteringPointOldUcLinkingComponent implements OnInit, OnChanges {
  constructor(
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private accountStore: Store<any>,
    private translate: TranslateService) {}

  @Input()
  customers: Customer[];
  @Input()
  meteringPoints: MeteringPoint[];  // Only Hot meteringpoints
  @Input()
  oldUcMinAge: number;
  @Input()
  oldUcMaxAge: number;
  @Input()
  ucProductCode: string;
  @Input()  
  districtHeatingSubstationCustomers: Customer[]; // Used to check if metering point already have a productInterest for district heating substation, then filter out.


  filteredMeteringPoints: MeteringPoint[] = [];
  meteringPointsWithOldUc: MeteringPoint[] = [];

  numberOfMeteringPointsWithOldUc = 0
  totalMeteringPointsWithOldUc = 0;
  ageOfCentral = 0;
  newUcRoute: string;

  ngOnInit() {

    dayjs.extend(duration);

    if (this.customers) {
      // Filter customers based on if user has SignServices permission and customer is not white label
      // let filteredCustomers = this.customers.filter(customer =>
      //   this.permissionService.checkPermissions([PermissionType.SignServices], customer.id) && !customer.isWhiteLabel
      // );

      //Filter out customers and their metering points that have district heating substation product interest, as those should not be shown in the old UC banner
      if (this.districtHeatingSubstationCustomers) {
        this.customers = this.customers.filter(customer => !this.districtHeatingSubstationCustomers.some(dhCustomer => dhCustomer.id === customer.id));
      }

      let filteredCustomers = this.customers.filter(customer => !customer.isWhiteLabel); 
      if(filteredCustomers.length > 0 ) {
        // Filter out meteringpoints that the User have access to, based on the customers they have (Admin + Fullständig) -access to
        this.filteredMeteringPoints = this.meteringPoints.filter(mp => filteredCustomers.some(customer => customer.id === mp.customerId)); 
      }
    }

    this.meteringPointsWithOldUc  = this.filteredMeteringPoints.filter(mp => {
      const age = this.calculateAge(mp);
      return age > this.oldUcMinAge && age < this.oldUcMaxAge;
    });
    this.numberOfMeteringPointsWithOldUc = this.meteringPointsWithOldUc.length;
    this.totalMeteringPointsWithOldUc = this.numberOfMeteringPointsWithOldUc;
    if(this.numberOfMeteringPointsWithOldUc === 1) {
      // Fetch UC age for meteringpoint
      this.ageOfCentral = this.calculateAge(this.meteringPointsWithOldUc[0]);
    }
    
    // Force the view to update
    this.changeDetectorRef.detectChanges();
  }

  capitalize = s => {
    if (typeof s !== 'string') {
      return '';
    }
    return s.charAt(0).toUpperCase() + s.slice(1);
  };

  ngOnChanges() {

  }

  containedMeteringPointsHasFunctionControl(meteringPoint: MeteringPoint): boolean {
    return meteringPoint.type === 'LOG' && meteringPoint.containedMeteringPoints?.some(mp => mp.hasFunctionControl);
  }

  // Ålder på fjärrkyla-/fjärrvärmecentral
  calculateAge(meteringPoint: MeteringPoint): number {
   
      let years = 0;
  
      let latestConstructionDateStr = meteringPoint.latestConstructionDate;
      if (!latestConstructionDateStr) {
        return 0;
      }
      //console.log('latestConstructionDateStr: ' + latestConstructionDateStr);
  
      let latestConstructionDate =  dayjs(latestConstructionDateStr);
      //console.log('latestConstructionDate: ' + latestConstructionDate);
    
      // First in Month (Used in FortumServices)
      let toDate = dayjs().startOf('month');
      //console.log('toDate: ' + toDate);
  
      let duration = dayjs.duration(toDate.diff(latestConstructionDate));
      let numberOfdays = duration.asDays();
      //console.log('numberOfdays: ' + numberOfdays);
  
      // numberofDays / 365.25 => to Integer
      years = Math.round(numberOfdays / 365.25);
      //console.log('years: ' + years);
      return years;
  }

  goToFilteredMeteringPointList() {
    
    if(this.meteringPointsWithOldUc.length > 1) {
      const oldUcChoice = this.translate.instant('meteringpoints.filter.misc.hasOldUc');

      this.accountStore
        .select(fromMeteringPointsStore.getMeteringPointSettings)
        .pipe(take(1))
        .subscribe((meteringPointSettings: MeteringPointSettings) => {
          const updatedFilterSettings: MeteringPointSettings = {
            ...(meteringPointSettings || {}),
            hotMeteringPointFilterSettings: {
              ...((meteringPointSettings && meteringPointSettings.hotMeteringPointFilterSettings) || {}),
              miscMultiChoiceFilter: {
                ...(
                  meteringPointSettings &&
                  meteringPointSettings.hotMeteringPointFilterSettings &&
                  meteringPointSettings.hotMeteringPointFilterSettings.miscMultiChoiceFilter
                    ? meteringPointSettings.hotMeteringPointFilterSettings.miscMultiChoiceFilter
                    : {}
                ),
                selections:
                  meteringPointSettings &&
                  meteringPointSettings.hotMeteringPointFilterSettings &&
                  meteringPointSettings.hotMeteringPointFilterSettings.miscMultiChoiceFilter &&
                  meteringPointSettings.hotMeteringPointFilterSettings.miscMultiChoiceFilter.selections
                    ? meteringPointSettings.hotMeteringPointFilterSettings.miscMultiChoiceFilter.selections
                    : [],
                selected: [oldUcChoice]
              }
            }
          };

          this.accountStore.dispatch(new fromMeteringPointsStore.MeteringPointsFilterSave(updatedFilterSettings));
          this.router.navigate(['/secure/meteringpoints/']);
        });
    }
  }

  goToProductDetailsPage() {

    if(this.meteringPointsWithOldUc.length === 1) {

      let meteringPoint = this.meteringPointsWithOldUc[0];
      let customerId = meteringPoint.customerId;
      let meteringPointId = meteringPoint.id;

      // Set selected CustomerId/MeteringPointId to be used in product page for pre-filling form, selected CustomerId
      // Redirect to component:
      //  - pass selected MeteringPointId/CustomerId and productNumber
      //  - should set path to new UC product page, with query param indicating productcategory/productId for new UC and pre-select CustomerId
      this.router.navigate([`/secure/products/${this.ucProductCode}/redirect/${customerId}/${meteringPointId}`]);
    }
  }
}
